var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showPage === true
    ? _c(
        "b-container",
        { staticClass: "result-page px-0" },
        [
          _c("div", { staticClass: "content-item d-flex w-100 flex-column" }, [
            _c(
              "div",
              { staticClass: "bg-white px-3 pb-3 pt-2 pt-sm-0 rounded-bottom" },
              [
                _c(
                  "div",
                  {
                    staticClass: "input-box py-1 flex-column align-items-start",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-between w-100 align-items-center bg-background px-1",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "d-none d-md-block" },
                          [
                            _vm.isMobile === false
                              ? _c("b-icon", {
                                  staticClass: "mx-2",
                                  attrs: {
                                    icon: "briefcase-fill",
                                    variant: "brand-dark",
                                    "font-scale": "1.2",
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                        _vm.selectedOccupations.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "badges-container flex-grow-1 w-100 p-1 pl-0 align-items-center",
                                class: _vm.isMobile === true ? "d-flex" : "",
                              },
                              [
                                _vm._l(
                                  _vm.selectedOccupations.slice(
                                    0,
                                    _vm.showAllOccupations === true
                                      ? _vm.selectedOccupationsCount
                                      : 1
                                  ),
                                  function (item, index) {
                                    return _c(
                                      "b-badge",
                                      { key: index, staticClass: "m-1" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "badge-text capitalize-first cursor-default",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.preferredLabel ||
                                                  item.label
                                              )
                                            ),
                                          ]
                                        ),
                                        _c("b-icon", {
                                          staticClass: "ml-1 clickable",
                                          attrs: {
                                            icon: "x",
                                            "font-scale": "1.5",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.badgeClicked(item)
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                _c(
                                  "div",
                                  { staticClass: "badge-occupation-count" },
                                  [
                                    _vm.isMobile
                                      ? _c(
                                          "p",
                                          {
                                            staticClass:
                                              "badge-amount text-brand-light mr-2 clickable",
                                            class:
                                              _vm.showAllOccupations == true
                                                ? "ml-2"
                                                : "",
                                            on: {
                                              click: function ($event) {
                                                return _vm.showAll()
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.showAllOccupations == true
                                                  ? _vm.t.general_ShowFewer
                                                  : "+" +
                                                      (
                                                        _vm.selectedOccupationsCount -
                                                        1
                                                      ).toString()
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _c("b-input", {
                              staticClass: "w-100 py-4",
                              attrs: {
                                disabled: true,
                                placeholder: _vm.content.noOccupationsSelected,
                              },
                            }),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "mt-1 bg-background" },
                  [
                    _c("LocationComponentsContainer", {
                      attrs: {
                        userInfo: _vm.userInfo,
                        useAllCountries: true,
                        useIcon: true,
                        locationToInit: _vm.locationToInit,
                        countryToInit: _vm.countryToInit,
                        settings: _vm.settings,
                        canSearchFromMap: true,
                      },
                      on: {
                        startSearch: function ($event) {
                          return _vm.startSearch(true)
                        },
                        removeLocation: function ($event) {
                          return _vm.resetProfileGeo()
                        },
                        countrySelected: function ($event) {
                          return _vm.resetProfileGeo()
                        },
                        emitParams: function ($event) {
                          return _vm.startSearch(true)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _vm.filterIsActive === true
                  ? _c("JobSearchFilters", {
                      attrs: {
                        filterIsActive: _vm.filterIsActive,
                        dateStartSearch: true,
                        filtersToExclude: _vm.filtersToExclude,
                      },
                      on: {
                        startSearch: function ($event) {
                          return _vm.startSearch(true)
                        },
                        changeMobileFiltersIsOpen: function ($event) {
                          return _vm.changeMobileFiltersIsOpen($event)
                        },
                      },
                    })
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end mt-2" },
                  [
                    _vm.content.jumpToWizardStepLink && _vm.isMobile === false
                      ? _c(
                          "a",
                          {
                            staticClass: "decorations-none",
                            attrs: {
                              href:
                                _vm.content.backToJobWizardLinkPicker +
                                "?jumpToStep=" +
                                _vm.content.jumpToWizardStepLink,
                            },
                          },
                          [
                            _c(
                              "b-button",
                              { staticClass: "btn btn-outline mr-2" },
                              [
                                _c("b-icon", {
                                  staticClass: "mr-3",
                                  attrs: { icon: _vm.iconOnJumpToStepButton },
                                }),
                                _vm._v(
                                  _vm._s(_vm.content.jumpToWizardStepText)
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-outline mr-2",
                        on: {
                          click: function ($event) {
                            return _vm.changeFilterActive()
                          },
                        },
                      },
                      [
                        _c("b-icon", {
                          staticClass: "mr-3",
                          attrs: {
                            icon: _vm.filterIsActive ? "chevron-up" : "sliders",
                            scale: "1.2",
                          },
                        }),
                        _vm._v(_vm._s(_vm.t.jobSearch_V2_Settings)),
                      ],
                      1
                    ),
                    _vm.isMobile === false
                      ? _c(
                          "b-dropdown",
                          {
                            staticClass: "small-dropdown steplink-dropdown",
                            attrs: {
                              text: _vm.content.backToJobWizardButtonText,
                              variant: "brand-light",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "button-content",
                                  fn: function () {
                                    return [
                                      _c("b-icon", {
                                        staticClass: "mr-2",
                                        attrs: {
                                          icon: "pencil-square",
                                          variant: "white",
                                          "font-scale": "1.2",
                                        },
                                      }),
                                      _vm._v(
                                        _vm._s(
                                          _vm.content.backToJobWizardButtonText
                                        )
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              false,
                              803159218
                            ),
                          },
                          [
                            _c("b-dropdown-text", { staticClass: "no-hover" }, [
                              _vm._v(_vm._s(_vm.t.general_Go_Back) + "..."),
                            ]),
                            _vm._l(
                              _vm.content.backToJobWizardLinks,
                              function (item, index) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: index,
                                    on: {
                                      click: function ($event) {
                                        return _vm.goToPage(item.link)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(item.name))]
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm.isLoading === false &&
          _vm.jobResult !== undefined &&
          _vm.jobPostings.length > 0
            ? _c(
                "div",
                { staticClass: "content-item w-100 mb-4" },
                [
                  _c(
                    "b-row",
                    {
                      staticClass:
                        "no-gutters mx-0 d-flex justify-content-center",
                    },
                    [
                      _c("h4", { staticClass: "text-brand-medium mt-4 mb-4" }, [
                        _vm._v(
                          _vm._s(_vm.jobPostingsTotalAmount) +
                            " " +
                            _vm._s(_vm.t.jobSearch_V2_Search_Is_Normal_Text)
                        ),
                      ]),
                    ]
                  ),
                  _c("JobViewContainer", {
                    attrs: {
                      jobPostings: _vm.jobPostings,
                      activeIndex: _vm.activeIndex,
                      selectedJobPosting: _vm.selectedJobPosting,
                      useSavedAdvert: true,
                      isSearching: _vm.isSearching,
                      jobmatch: true,
                      content: _vm.content,
                      jobApplicationAccess: _vm.jobApplicationAccess,
                    },
                    on: {
                      searchForMore: function ($event) {
                        return _vm.searchForMore()
                      },
                      setActiveIndex: function ($event) {
                        return _vm.setActiveIndex($event)
                      },
                      setSelectedJobPosting: function ($event) {
                        return _vm.setSelectedJobPosting($event)
                      },
                    },
                  }),
                ],
                1
              )
            : _vm.isLoading === false &&
              _vm.jobResult !== undefined &&
              _vm.jobPostings !== undefined &&
              _vm.jobPostings.length <= 0
            ? _c("div", { staticClass: "content-item w-100 mt-4" }, [
                _c(
                  "h4",
                  {
                    staticClass:
                      "text-brand-medium d-flex justify-content-center pb-4 font-weight-bold",
                  },
                  [_vm._v(_vm._s(_vm.t.jobSearch_V2_No_Search_Result))]
                ),
              ])
            : _c(
                "div",
                { staticClass: "content-item w-100 mt-4" },
                [
                  _vm.isMobile
                    ? _c(
                        "b-row",
                        {
                          staticClass:
                            "skeleton-container no-gutters mx-0 d-flex justify-content-center mb-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-none d-md-flex" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mr-2",
                                attrs: {
                                  width: "60px",
                                  variant: "light",
                                  height: "28px",
                                },
                              }),
                              _c("b-skeleton", {
                                attrs: {
                                  width: "200px",
                                  variant: "light",
                                  height: "28px",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "d-flex d-md-none" },
                            [
                              _c("b-skeleton", {
                                staticClass: "mr-2",
                                attrs: { width: "60px", height: "28px" },
                              }),
                              _c("b-skeleton", {
                                attrs: { width: "200px", height: "28px" },
                              }),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("JobResultSkeleton"),
                ],
                1
              ),
          _c("MobileButtonBottom", {
            attrs: {
              selectedJobPosting: _vm.selectedJobPosting,
              mobileFilterIsActive: _vm.mobileFilterIsActive,
              content: _vm.content,
              iconOnJumpToStepButton: _vm.iconOnJumpToStepButton,
              jobmatch: true,
              jobApplicationAccess: _vm.jobApplicationAccess,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }